/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import RefreshIcon from '@material-ui/icons/Refresh';
import { Action, Column, Options } from '@infotrack/presentacion-componentes/tabla';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import ITipoCuentaBancaria from 'Infotrack@Modelos/administracion/tipoCuentaBancaria/entidades/tipoCuentaBancaria';
import { BotonAgregar, BotonRefrescar } from 'Infotrack@Transversales/componentes/botonesAcciones';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const columnas = (
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string
): Array<Column<ITipoCuentaBancaria>> => [
    {
        title: formatMessage({ id: 'tipoCuentaBancaria.codigoTipoCuentaBancaria' }),
        field: 'CodigoTipoCuentaBancaria',
    },
    {
        title: formatMessage({ id: 'tipoCuentaBancaria.nombreTipoCuentaBancaria' }),
        field: 'NombreTipoCuentaBancaria',
    },
    {
        title: formatMessage({ id: 'tipoCuentaBancaria.estadoTipoCuentaBancaria' }),
        field: 'EstadoTipoCuentaBancaria',
        type: 'boolean',
    },
];

export const acciones = (
    manejarFormulario: (tipoFormulario: TipoFormulario, tipoCuentaBancaria?: ITipoCuentaBancaria) => void,
    cargarTipoCuentaBancaria: () => void,
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string,
    confirmarEliminacion: (tipoCuentaBancaria: ITipoCuentaBancaria) => void
): Array<Action<ITipoCuentaBancaria>> => [
    {
        component: BotonAgregar,
        icon: () => <AddIcon />,
        onClick: () => manejarFormulario(TipoFormulario.Creacion, undefined),
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.agregar' }),
    },
    {
        icon: () => <EditIcon color="action" />,
        onClick: (_, value) => manejarFormulario(TipoFormulario.Edicion, value as ITipoCuentaBancaria),
        tooltip: formatMessage({ id: 'boton.editar' }),
    },
    {
        component: BotonRefrescar,
        icon: () => <RefreshIcon />,
        onClick: cargarTipoCuentaBancaria,
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.refrescar' }),
    },
    {
        icon: () => <DeleteIcon color="action" />,
        onClick: (_, value) => confirmarEliminacion(value as ITipoCuentaBancaria),
        tooltip: formatMessage({ id: 'boton.eliminar' }),
    },
];

export const opciones: Options<ITipoCuentaBancaria> = {
    maxBodyHeight: '50vh',
};
